module.exports = __webpack_public_path__ + "static/media/PDF_41.31e332f6.pdf";